export default {
  boxShadow: "0 2px 3px rgba(0,0,0,0.05)",
  headerHeight: 52,
  skewAngle: -2.5,
  breakpointSmall: 450,
  breakpointMedium: 768,
  breakpointLarge: 960,
}